import { get } from "lodash";

export const selectIsLoading = (state) => get(state, "general.loading", 0) > 0;
export const failed = (state) => get(state, "general.failed", false);
